export default {"src":"/_next/static/media/ic-more.7f3d5500.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};